import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=fa889ac2&scoped=true&"
import script from "./MyRequests.vue?vue&type=script&lang=js&"
export * from "./MyRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa889ac2",
  null
  
)

export default component.exports